<template>
  <div class="border-x border-divider" :class="{ 'mx-2': isSms }">
    <div class="mx-4 my-2 flex space-x-2-5">
      <div class="border-l-1 border-success" />
      <div
        class="flex-1 rounded border border-divider p-4 text-headline shadow-sm"
        data-cy="reply-to-message"
      >
        <content-show-hide
          :content
          :initial-max-height="80"
          @button:click="emit('button:click')"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import ContentShowHide from "@/components/communicationLogs/communication/ContentShowHide.vue";

const { content, isSms = false } = defineProps<{
  content: string;
  isSms?: boolean;
}>();

const emit = defineEmits<{
  "button:click": [];
}>();
</script>
